// extracted by mini-css-extract-plugin
export default {"group":"x2cvx9YPVsEGoQJuNlMl","groupHeader":"jOeQFV3RUgJ7ALMmTGCg","groupDescription":"WpB_z3_KsOZIf8h3C_Ph"};